import { render, staticRenderFns } from "./SpecialRequestsTable.vue?vue&type=template&id=0a06ec93&scoped=true"
import script from "./SpecialRequestsTable.vue?vue&type=script&lang=js"
export * from "./SpecialRequestsTable.vue?vue&type=script&lang=js"
import style0 from "./SpecialRequestsTable.vue?vue&type=style&index=0&id=0a06ec93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a06ec93",
  null
  
)

export default component.exports